import { marketSearchApi } from '@envato/foundation-types'
import omit from 'lodash-es/omit'

import { ILocationParams } from '../../../../common/reducers/reactRouterLocation'

const isRoot = (filterItem: marketSearchApi.IFilterOption): boolean =>
  filterItem.key === ''

const isSoftwareType = (filterItem: marketSearchApi.IFilterOption): boolean =>
  filterItem.key.split(' ').length === 1

export const softwareTypeFromString = (softwareType: string): string =>
  softwareType.split(' ')[0]

const getSoftwareType = (filterItem: marketSearchApi.IFilterOption): string =>
  softwareTypeFromString(filterItem.key)

export const filterNodeFrom = (
  filterItem: marketSearchApi.IFilterOption
): marketSearchApi.IFilterTreeNode => {
  const name = filterItem.name || filterItem.label || ''
  return {
    children: [] as marketSearchApi.IFilterTreeNode[],
    name,
    ...filterItem
  }
}

const sortReverseVersion = (nodes?: marketSearchApi.IFilterTreeNode[]) => {
  return (nodes || []).sort((node1, node2) => (node1.key > node2.key ? -1 : 1))
}

export const buildTreeFromFilterItems = (
  filterItems: marketSearchApi.IFilterOption[]
): marketSearchApi.IFilterTreeNode[] => {
  const tree: marketSearchApi.IFilterTreeNode[] = []

  filterItems.forEach(filterItem => {
    if (isRoot(filterItem)) {
      return
    }

    if (isSoftwareType(filterItem)) {
      const filterNode = filterNodeFrom(filterItem)
      tree.push(filterNode)
    } else {
      const softwareType = getSoftwareType(filterItem)
      const parent = tree.find(softwareTypeNode => {
        return softwareTypeNode.key === softwareType
      })
      if (parent) {
        parent.children.push(filterNodeFrom(filterItem))
      }
    }
  })

  tree.forEach(filterNode => {
    filterNode.children = sortReverseVersion(filterNode.children)
  })

  return tree
}

export const locationParamsForPlatform = (
  platform: string,
  locationParams: ILocationParams
): ILocationParams => {
  return {
    ...omit(locationParams, ['page']),
    platform
  }
}
